// src/pages/TerminosCondiciones.jsx
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowLeft } from "lucide-react";

export default function TerminosCondiciones() {
  return (
    <section className="min-h-screen py-28 md:py-40 px-6 lg:px-10 bg-background">
      <div className="max-w-4xl mx-auto">
        {/* Volver */}
        <Link
          to="/"
          className="inline-flex items-center gap-2 text-muted-foreground hover:text-foreground transition-colors mb-10 text-sm font-light"
        >
          <ArrowLeft size={16} /> Volver al inicio
        </Link>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          <h1 className="font-serif-display text-4xl md:text-5xl font-light text-foreground mb-4">
            Términos y Condiciones
          </h1>
          <p className="text-sm text-muted-foreground font-light mb-12">
            Última actualización: agosto de 2026
          </p>

          <div className="space-y-8 text-foreground/80 font-light leading-relaxed">
            <section>
              <h2 className="font-serif-display text-2xl text-foreground mb-4">
                1. Aceptación de los Términos
              </h2>
              <p>
                Al acceder y utilizar el sitio web de Casa El Gavillero, usted
                acepta cumplir con estos Términos y Condiciones. Si no está de
                acuerdo con alguno de estos términos, le solicitamos no utilizar
                nuestro sitio web ni nuestros servicios.
              </p>
            </section>

            <section>
              <h2 className="font-serif-display text-2xl text-foreground mb-4">
                2. Reservaciones y Pagos
              </h2>
              <ul className="list-disc pl-6 space-y-2 text-sm">
                <li>
                  <strong>Confirmación:</strong> Todas las reservaciones están
                  sujetas a disponibilidad y confirmación por parte de Casa El
                  Gavillero.
                </li>
                <li>
                  <strong>Pagos:</strong> Los pagos se procesarán a través de
                  nuestros sistemas de pago seguros. Aceptamos las tarjetas de
                  crédito/débito indicadas en el proceso de reserva.
                </li>
                <li>
                  <strong>Política de Cancelación:</strong> Las cancelaciones
                  deberán realizarse con al menos 48 horas de anticipación para
                  evitar cargos. En caso de no presentarse, se aplicará el cargo
                  correspondiente a la primera noche.
                </li>
              </ul>
            </section>

            <section>
              <h2 className="font-serif-display text-2xl text-foreground mb-4">
                3. Uso del Sitio Web
              </h2>
              <ul className="list-disc pl-6 space-y-2 text-sm">
                <li>
                  El sitio web es únicamente para uso personal y no comercial.
                </li>
                <li>
                  No está permitido copiar, reproducir o distribuir el contenido
                  del sitio sin autorización expresa.
                </li>
                <li>
                  Usted se compromete a proporcionar información veraz y actualizada
                  al realizar una reserva.
                </li>
              </ul>
            </section>

            <section>
              <h2 className="font-serif-display text-2xl text-foreground mb-4">
                4. Propiedad Intelectual
              </h2>
              <p>
                Todo el contenido del sitio web, incluyendo textos, imágenes, logos,
                diseños y software, es propiedad de Casa El Gavillero o de sus
                licenciantes, y está protegido por las leyes de propiedad intelectual
                aplicables.
              </p>
            </section>

            <section>
              <h2 className="font-serif-display text-2xl text-foreground mb-4">
                5. Limitación de Responsabilidad
              </h2>
              <ul className="list-disc pl-6 space-y-2 text-sm">
                <li>
                  Casa El Gavillero no se hace responsable por daños o perjuicios
                  derivados del uso del sitio web.
                </li>
                <li>
                  La información proporcionada en el sitio es solo para fines
                  informativos y puede estar sujeta a cambios sin previo aviso.
                </li>
                <li>
                  No garantizamos que el sitio web esté libre de errores o
                  interrupciones.
                </li>
              </ul>
            </section>

            <section>
              <h2 className="font-serif-display text-2xl text-foreground mb-4">
                6. Ley Aplicable y Jurisdicción
              </h2>
              <p>
                Estos Términos y Condiciones se rigen por las leyes de los Estados
                Unidos Mexicanos. Cualquier controversia derivada del uso de este
                sitio web será resuelta por los tribunales competentes de
                Tequisquiapan, Querétaro.
              </p>
            </section>

            <section>
              <h2 className="font-serif-display text-2xl text-foreground mb-4">
                7. Contacto
              </h2>
              <p className="text-sm bg-secondary/30 p-4 rounded-sm border border-border">
                Si tiene preguntas sobre estos Términos y Condiciones, puede
                contactarnos en:
                <br />
                ✉️ reservaciones@casaelgavillero.com.mx
                <br />
                📞 (414) 219 63 66
              </p>
            </section>

            <div className="border-t border-border pt-8 mt-8 text-sm text-muted-foreground">
              <p>
                Estos Términos y Condiciones se rigen por el Código Civil Federal
                y la Ley Federal de Protección al Consumidor.
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
}